<sm-item-list-item
  [item]="item"
  [loadGalleryImages]="loadGalleryImages"
  [imageLongPressEnabled]="true"
  [searchQuery]="searchQuery"
  [menuItems]="menuItems"
  [emptyDescriptionLabel]="emptyDescriptionLabel"
  [menuAriaLabel]="menuAriaLabel"
  (open)="handleOpen()"
  (menuItemSelect)="handleMenuItemSelect($event)">
</sm-item-list-item>
